import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { confirmForgotPassword } from "../../api/accountsService";

const ForgotPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { uid, token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!uid || !token) setError("Invalid reset link.");
  }, [uid, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    try {
      await confirmForgotPassword(uid, token, newPassword);
      setSuccess("Password reset successful.");
      setError("");
      navigate("/login", { replace: true });
    } catch (err) {
      console.error(err);
      const message =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Something went wrong. Please try again.";
      setError(Array.isArray(message) ? message.join(" ") : message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-indigo-500 to-blue-500 px-4 py-8">
      <div className="w-full max-w-lg bg-white/10 backdrop-blur-xl rounded-3xl border border-white/20 p-6 sm:p-8 shadow-lg">

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6 text-center">
          Reset Your Password
        </h2>

        {error && <div className="text-red-400   text-center mb-4 text-sm">{error}</div>}
        {success && <div className="text-green-400 text-center mb-4 text-sm">{success}</div>}

        <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
          <div>
            <label className="block text-white/80 text-sm mb-2">New Password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter your new password"
              required
              className="w-full p-3 sm:p-4 rounded-xl bg-white/5 text-white placeholder-white/60
                border border-white/30 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            />
          </div>

          <div>
            <label className="block text-white/80 text-sm mb-2">Confirm New Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm your new password"
              required
              className="w-full p-3 sm:p-4 rounded-xl bg-white/5 text-white placeholder-white/60
                border border-white/30 focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-500
              text-white font-semibold shadow-lg hover:opacity-95 active:scale-[0.98] transition-all duration-300"
          >
            Reset Password
          </button>
        </form>

        <div className="text-center mt-6">
          <button
            onClick={() => navigate("/login", { replace: true })}
            className="text-white/60 hover:text-white transition duration-300 text-sm"
          >
            ← Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;